import axios from "axios";
import * as actionTypes from "./actionTypes";
import { openSuccess, openError, openInfo } from "./notification"

export const getList = list => ({
  type: actionTypes.GET_VPNS,
  list
})

export const getVPNs = () =>
  dispatch => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/vpn/`, {
    })
      .then(res => {
        dispatch(getList(res.data.results));
      })
      .catch((err) => {
        console.error("Failed to fetch VPNs:", err);
      });
  }


export const createVPN = (ipAddr, port, description, assignTo, location) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/vpn/create`, {
        port,
        description,
        ip_addr: ipAddr,
        assign_to: assignTo,
        location
      }, { headers })
      .then((res) => {
        if (res)
          dispatch(getVPNs());
        dispatch(openSuccess(true, "Create Success!", "New VPN has been created.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Create Failed!", "There was an error to create.", "Just now"));
      });

  };


export const updateVPN = (id, ipAddr, port, description, assignTo, location) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/vpn/update/${id}/`, {
        port,
        description,
        ip_addr: ipAddr,
        assign_to: assignTo,
        location
      }, { headers })
      .then(res => {
        if (res)
          dispatch(getVPNs());
        dispatch(openInfo(true, "Update Success!", "The VPN has been updated.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Update Failed!", "There was an error to update.", "Just now"));
      });
  };


export const deleteVPN = (id) =>
  dispatch => {
    
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };

    axios
      .delete(`${process.env.REACT_APP_SERVER_URL}/api/vpn/delete/${id}/`, { headers })
      .then(res => {
        if (res)
          dispatch(getVPNs());
        dispatch(openSuccess(true, "Delete Success!", "The VPN has been deleted.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Delete Failed!", "There was an error to delete.", "Just now"));
      });
  };




